import { Component, Host, Input, Optional } from '@angular/core';
import { EaGroupOptions } from './ea-groups/ea-groups.component';

export class EaGroupValue {
  icon?: string;
  label: any;
  value: any;
  suffix?: string;
  tooltip?: string;
  options?: { class: string };
  showOnlyIf?: (simulation: any) => boolean;

  constructor(
    icon: string,
    label: string,
    value: any,
    suffix: string,
    tooltip?: string,
    showOnlyIf?: (simulation: any) => boolean,
    options?: any,
  ) {
    this.icon = icon;
    this.label = label;
    this.value = value;
    if (suffix) this.suffix = suffix;
    if (tooltip) this.tooltip = tooltip;
    if (showOnlyIf) this.showOnlyIf = showOnlyIf;
    if (options) this.options = options;
  }
}

export class EaGroup {
  label: any;
  values: EaGroupValue[];
  showContent?(simulation): boolean;

  constructor(
    label: string,
    values: EaGroupValue[],
    showContent?: () => boolean,
  ) {
    this.label = label;
    this.values = values;
    this.showContent = showContent;
  }
}

@Component({
    selector: 'ea-group',
    templateUrl: './ea-group.component.html',
    styleUrls: ['./ea-group.component.scss'],
    standalone: false
})
export class EaGroupComponent {
  @Input() context: any;
  @Input() group: EaGroup;
  @Input() options: EaGroupOptions;
  @Input() clazz: string;

  constructor() {}

  evalValue(value: EaGroupValue) {
    let _value;
    try {
      _value = value.value(this.context);
    } finally {
      if (_value != undefined && _value != null && value.suffix)
        _value += ' ' + value.suffix;

      if (!_value && _value !== 0) _value = 'N/C';

      return _value;
    }
  }

  showOnlyIf(value: EaGroupValue) {
    return this.context && value.showOnlyIf
      ? value.showOnlyIf(this.context)
      : true;
  }

  /**
   * Résout une valeur qui peut être soit une constante, soit une fonction paresseuse à
   * appeler avec le contexte du composant.
   *
   * Ne pas la renommer avec le nom de la fonction JavaScript d'évaluation : cette méthode
   * n'évalue aucune chaîne, mais porter ce nom faisait remonter le composant à chaque recherche
   * lors des audits de sécurité (CASA 5.1.3), en donnant l'apparence d'une exécution dynamique
   * de code.
   */
  resolveValue(val) {
    return typeof val === 'function' ? val(this.context) : val;
  }
}
